import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const PartyhatFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 872.722656 302.007812 C 880.054688 305.113281 887.386719 308.222656 894.71875 311.328125 C 915.171875 330.535156 918.101562 352.3125 903.511719 376.667969 C 895.433594 386.964844 884.902344 393.316406 871.925781 395.710938 C 874.554688 490.671875 876.738281 585.636719 878.476562 680.605469 C 873.773438 697.199219 862.925781 705.574219 845.929688 705.730469 C 771.6875 674.273438 697.445312 642.820312 623.199219 611.367188 C 616.507812 604.207031 613.074219 595.726562 612.902344 585.925781 C 615.425781 579.96875 617.953125 574.011719 620.476562 568.054688 C 690.855469 505.105469 759.972656 440.890625 827.824219 375.40625 C 815.203125 353.816406 817.277344 333.617188 834.050781 314.808594 C 837.320312 311.015625 841.074219 310.445312 845.316406 313.097656 C 846.167969 315.230469 846.304688 317.449219 845.734375 319.757812 C 824.671875 343.035156 827.074219 363.507812 852.945312 381.183594 C 878.019531 387.316406 893.925781 377.839844 900.671875 352.761719 C 900.449219 331.753906 889.941406 318.925781 869.144531 314.273438 C 862.382812 316.292969 856.398438 315.105469 851.1875 310.71875 C 851.957031 308.292969 853.160156 306.097656 854.789062 304.136719 C 860.804688 302.765625 866.785156 302.054688 872.722656 302.007812 Z M 872.722656 302.007812 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 845.316406 313.097656 C 847.476562 312.703125 849.433594 311.910156 851.1875 310.71875 C 856.398438 315.105469 862.382812 316.292969 869.144531 314.273438 C 889.941406 318.925781 900.449219 331.753906 900.671875 352.761719 C 893.925781 377.839844 878.019531 387.316406 852.945312 381.183594 C 827.074219 363.507812 824.671875 343.035156 845.734375 319.757812 C 846.304688 317.449219 846.167969 315.230469 845.316406 313.097656 Z M 845.316406 313.097656 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 816.859375 403.1875 C 820.417969 406.089844 821.773438 409.90625 820.925781 414.640625 C 816.035156 433.6875 804.6875 439.417969 786.878906 431.832031 C 797.441406 422.828125 807.433594 413.277344 816.859375 403.1875 Z M 816.859375 403.1875 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 859.339844 482.796875 C 861.925781 484.011719 862.945312 486.066406 862.402344 488.957031 C 862.699219 518.460938 863.4375 547.960938 864.625 577.453125 C 836.945312 573.316406 822.535156 556.941406 821.386719 528.332031 C 823.886719 504.441406 836.539062 489.265625 859.339844 482.796875 Z M 859.339844 482.796875 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 755.523438 459.890625 C 766.894531 473.570312 769.539062 489.011719 763.457031 506.21875 C 744.507812 538.253906 719.371094 544.628906 688.046875 525.34375 C 687.710938 523.578125 688.292969 522.203125 689.792969 521.21875 C 712.351562 501.398438 734.261719 480.957031 755.523438 459.890625 Z M 755.523438 459.890625 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 865.902344 650.957031 C 866.675781 659.695312 867.003906 668.480469 866.894531 677.320312 C 864.652344 687.492188 858.398438 692.679688 848.132812 692.882812 C 841.902344 691.050781 835.847656 688.757812 829.96875 685.996094 C 832.925781 679.660156 835.414062 673.152344 837.4375 666.460938 C 835.785156 661.4375 832.574219 660.078125 827.816406 662.382812 C 824.417969 668.492188 821.46875 674.808594 818.96875 681.335938 C 811.179688 678.035156 803.386719 674.734375 795.597656 671.433594 C 798.550781 665.097656 801.039062 658.589844 803.066406 651.898438 C 801.449219 646.945312 798.46875 645.679688 794.128906 648.113281 C 790.167969 653.683594 786.992188 659.902344 784.597656 666.773438 C 777.265625 663.667969 769.933594 660.5625 762.601562 657.453125 C 765.871094 650.957031 768.132812 644.347656 769.382812 637.628906 C 768.207031 633.585938 765.421875 631.863281 761.027344 632.46875 C 757.433594 639.035156 754.292969 645.808594 751.601562 652.792969 C 743.808594 649.492188 736.019531 646.191406 728.226562 642.890625 C 731.183594 636.558594 733.671875 630.046875 735.699219 623.359375 C 734.042969 618.332031 730.835938 616.972656 726.074219 619.28125 C 722.675781 625.386719 719.726562 631.703125 717.230469 638.230469 C 709.4375 634.929688 701.648438 631.628906 693.855469 628.328125 C 696.808594 621.996094 699.300781 615.484375 701.324219 608.792969 C 699.671875 603.769531 696.464844 602.410156 691.703125 604.71875 C 688.304688 610.824219 685.355469 617.140625 682.855469 623.671875 C 675.066406 620.367188 667.277344 617.070312 659.484375 613.765625 C 662.4375 607.433594 664.929688 600.921875 666.953125 594.234375 C 665.796875 590.335938 663.242188 588.710938 659.289062 589.363281 C 655.695312 595.929688 652.550781 602.707031 649.859375 609.691406 C 643.332031 607.191406 637.011719 604.246094 630.902344 600.847656 C 624.027344 592.546875 624.058594 584.183594 630.996094 575.757812 C 636.507812 570.183594 642.207031 565.03125 648.089844 560.300781 C 720.980469 589.566406 793.585938 619.785156 865.902344 650.957031 Z M 865.902344 650.957031 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 218.75 308.691406 L 697.917969 308.691406 C 709.421875 308.691406 718.75 318.015625 718.75 329.519531 L 718.75 808.566406 C 718.75 820.066406 709.421875 829.394531 697.917969 829.394531 L 218.75 829.394531 C 207.242188 829.394531 197.917969 820.066406 197.917969 808.566406 L 197.917969 329.519531 C 197.917969 318.015625 207.242188 308.691406 218.75 308.691406 Z M 218.75 308.691406 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="950.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
